
import {makeStyles} from "@material-ui/core";
import {themeTypeToBool} from '../../../utils/helpers';

export default makeStyles(theme => ({
    container: {
        minWidth: 400,
        maxWidth: "100%",
        height: 130 + 290 + theme.spacing(2),
        position: "relative",
        margin: theme.spacing(1),
        background: theme.palette.background.paper
    },
    title: {
        paddingTop: 15,
        paddingBottom: 5,
        paddingLeft: 5,
        width: "90%",
        margin: "auto",
    },
    table: {
        width: "90%",
        margin: "auto",
        marginBottom: 30,
        marginTop: 10,
        borderCollapse: "initial"
    },
    tableHeader: {
        align: "right",
        paddingTop: 5,
        paddingBottom: 5,
        fontWeight: 500,
        height: 20,
        border: "solid",
        borderColor: "#707070",
        borderWidth: "0 0 1px 0",
    },
    tableCell: {
        align: "right",
        paddingTop: 5,
        paddingBottom: 5
    },
    tableRow: {
        // height: 10,
        border: "solid",
        borderColor: "#707070",
        borderWidth: "1px 0 1px 0",
        background: themeTypeToBool(theme.palette.type) ? "#F1F1F1" : "#43425D",
    },
    button: {
        background: themeTypeToBool(theme.palette.type) ? "rgba(255,255,255,0.4)" : "rgba(0,0,0,0.2)"
    },
    moreLink: {
        color: themeTypeToBool(theme.palette.type) ? "#3B86FF" : "#F0F2F8",
        textDecoration: "none",
        paddingTop: 10
    }
}));